require('./fm.liveswitch.js');
const xirsys = require('./fm.liveswitch.xirsys.js');

const fm = global.fm;

module.exports = {
  fm,
  xirsys,
};
